/*
 * @Descripttion:  不要直接给组件赋值classname
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-11-10 11:11:34
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-05 14:22:21
 */
import React, { PureComponent, Fragment } from 'react'
import { Avatar, Col, Row, Input, Tabs, Divider, Pagination, Button, Radio, Badge, Select, message } from 'antd';
import './index.css'
class CustomModal extends React.PureComponent {
    state = {
        visible: false
    }
    componentWillMount() {

    }
    componentDidMount() {
        // if (this.props.dragable) {
        var content = this.refs.content
        var div=content.getElementsByClassName("modal-dragable")
        Array.from(div).forEach(div1 => {
            if (div1) {
                div1.onmousedown = function (ev) {
                    var oevent = ev
                    var distanceX = oevent.clientX - content.offsetLeft;
                    var distanceY = oevent.clientY - content.offsetTop;
                    // console.log("oevent.clientx:" + oevent.clientX + "oevent.clientY:" + oevent.clientY)//鼠标绝对位置
                    // console.log("offsetLeft:" + content.offsetLeft + "offsetTop:" + content.offsetTop)//面板相对浏览器位置 由于设置了transform: translate(-50%, -50%);改变了
                    // console.log("x:" + distanceX + "y:" + distanceY)
                    // var dropx = oevent.clientX;
                    // var dropy = oevent.clientY;
                    document.onmousemove = function (ev) {
                        var oevent = ev
                        // if (oevent.clientX < 100 || oevent.clientX > window.innerWidth - 100 || oevent.clientY < 100 || oevent.clientY > window.innerHeight - 100) {
                        //     return
                        // }      
                        // console.log("oevent.clientx:")              
                        if (oevent.clientX - distanceX - content.offsetWidth / 2 < 0) {//左
                            content.style.left = content.offsetWidth / 2 + 'px';
                        } else if (oevent.clientX - distanceX + content.offsetWidth / 2 > window.innerWidth) {
                            content.style.left = window.innerWidth - content.offsetWidth / 2 + 'px';
                        }
                        else {
                            content.style.left = oevent.clientX - distanceX + 'px';
                        }
                        if (oevent.clientY - distanceY - content.offsetHeight / 2 < 0) {
                            content.style.top = content.offsetHeight / 2 + 'px';
                        } else if (oevent.clientY - distanceY + content.offsetHeight / 2 > window.innerHeight) {
                            content.style.top = window.innerHeight - content.offsetHeight / 2 + 'px';
                        }
                        else {
                            content.style.top = oevent.clientY - distanceY + 'px';
                        }

                    };
                    document.onmouseup = function () {
                        // content.style.left = dropx - distanceX + 'px';
                        // content.style.top = dropy - distanceY + 'px';
                        document.onmousemove = null;
                        document.onmouseup = null;
                    };
                }
            }
        });


    }
    show = () => {
        this.setState({ visible: true })
    }
    close = () => {
        // console.log("close clicked");

        this.setState({ visible: false })
    }
    handle = (e) => {
        //阻止下层元素接收点击事件
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        // console.log("panel clicked");
    }
    render() {
        return (
            // 灰色背景
            <div className={this.state.visible ? 'modalback-vis' : 'modalback-invis'} onClick={() => {
                if (this.props.backclose) this.close()
            }}>
                {/* 具体面板 */}
                <div className='modal-content' ref='content' {...this.props} onClick={this.handle}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
CustomModal.defaultProps={
    backclose:null
}
export default CustomModal